import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, ControlValueAccessor } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-material-file-uploader',
  templateUrl: './material-file-uploader.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => MaterialFileUploadComponent),
  },
  {
    provide: NG_VALIDATORS,
    multi: true,
    useExisting: forwardRef(() => MaterialFileUploadComponent),
  }],
  imports: [
    SharedModule,
    MatInputModule,
    MatIconModule
  ]
})
export class MaterialFileUploadComponent implements ControlValueAccessor, Validator {

  currentFiles?: FileList;
  _accept!: string;
  _disabled: boolean = false;
  fileName: string = '';

  onChange = (_value: FileList | undefined) => { };
  onTouched = () => { };

  @Input() set accept(value: string) {
    this._accept = value;
  }

  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }

  @Input() required = false;

  valueChanged(fileEvent: any) {
    if (fileEvent.target.files) {
      this.fileName = fileEvent.target.files[0].name;
      this.currentFiles = fileEvent.target.files;
      this.onChange(this.currentFiles);
    } else {
      this.fileName = '';
      this.currentFiles = undefined;
      this.onChange(undefined);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.fileName = value || '';
  }

  validate(): ValidationErrors | null {
    if (this.required && !this.fileName) {
      return { required: true };
    }
    return null;
  }
}